import { CommonModule } from '@angular/common';
import { Component, Input, inject, type OnInit } from '@angular/core';
import { Router } from '@angular/router';
import type { HighlightItem } from '../../../core/models/highlight-item.model';

@Component({
  selector: 'app-highlight-teaser',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './highlight-teaser.component.html',
})
export class HighlightTeaserComponent implements OnInit {
  @Input() highlight?: HighlightItem;

  private readonly router = inject(Router);

  ngOnInit(): void {}

  onTeaserClick(highlight: HighlightItem): void {
    this.router.navigate(['event', 'overview', highlight.eventType, highlight.eventDocumentId]);
  }
}
